export enum RoleOptions {
  ALL = "All",
  SOFTWARE_ENGINEER = "Software Engineer",
  TECH_LEAD = "Tech Lead",
  QA_ENGINEER = "QA Engineer",
  PROJECT_MANAGER = "Project Manager",
  HUMAN_RESOURCE = "Human Resource",
  USER_EXPERIENCE = "User Experience",
  CUSTOMER_SUPPORT = "Customer Support",
}
